import { request } from '../../utils/request';

export const deleteProduct = (id: number, authToken: string) =>
  request({
    method: 'DELETE',
    url: `/products/${id}`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
